export const stopPropagate = (callback: () => void) => {
  return (e: any) => {
    e.stopPropagation();
    e.preventDefault();
    callback();
  };
};
